import { render, staticRenderFns } from "./IBSMun.vue?vue&type=template&id=2992e391&"
import script from "./IBSMun.vue?vue&type=script&lang=js&"
export * from "./IBSMun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports